// extracted by mini-css-extract-plugin
export default {"imgContainer":"imgContainer___PUic8","clickable":"clickable___NlcWY"};